/**
 * @deprecated Import from office-ui-fabric-react package instead.
 */
export { Stack } from 'office-ui-fabric-react/lib/Stack';
